import React from 'react';
import { Link } from 'react-router-dom';
import { useAuthenticator } from '@aws-amplify/ui-react';

function Home() {
  const { user, signOut } = useAuthenticator((context) => [context.user]);

  return (
    <div className="home">
      <h1>Welcome to My App</h1>
      <p>This is the main page of your app. Navigate through the sections to explore the features.</p>

      <div>
        {user ? (
          <>
            <p>ログイン中です</p>
            <nav>
              <ul>
                <li><Link to="/game">Game</Link></li>
                <li><button onClick={signOut}>Sign Out</button></li>
              </ul>
            </nav>
          </>
        ) : (
          <>
            <p>ログアウト中です</p>
            <nav>
              <ul>
                <li><Link to="/signin">Sign In</Link></li>
                <li><Link to="/game">Game</Link></li>
              </ul>
            </nav>
          </>
        )}
      </div>

      <section>
        <h2>Latest Updates</h2>
        <p>Here you can find the latest news and updates related to the app.</p>
      </section>
    </div>
  );
}

export default Home;
